import { keepPreviousData, useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { toast } from '@hivebrite/design-system/Toast';

import { captureException } from 'hb-react/shared/utils/errorReporting';

import { getGroupsRequest } from '../requests';

export const useQueryGroups = ({
  params,
  networkId,
}: {
  networkId: number;
  params: { fulltext: string; limit: number };
}) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['groups', networkId, params.fulltext].filter(Boolean),
    queryFn: async ({ signal }) => {
      try {
        const response = await getGroupsRequest({
          params,
          signal,
        });

        const groups = response.data.data;

        return groups;
      } catch (error) {
        captureException(error);
        toast.error(__('Sorry, an error occurred'));
        throw error;
      }
    },
    staleTime: ms('1h'),
    placeholderData: keepPreviousData,
  });

  return { data: data || [], isLoading, refetch };
};
